import { clsx } from "clsx";
import { useState } from "react";

type Props = {
  icon: React.ReactNode;
  children: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  active?: boolean;
};

export const FilterButton = ({
  icon,
  children,
  disabled,
  active,
  onClick,
}: Props) => {
  const [hover, setHover] = useState(false);
  return (
    <div className={clsx("flex flex-col h-full min-h-[28px] desktop:h-[34px]")}>
      <button
        onClick={(e) => {
          setHover(false);
          onClick(e);
        }}
        className={clsx(
          "flex pl-1.5 pr-2 py-0.5 gap-x-1.5 rounded-lg w-full h-full items-center",
          active
            ? hover
              ? "bg-primary-blue"
              : "bg-primary-dark-blue"
            : hover
              ? "bg-gray-875"
              : "bg-gray-900",
        )}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        disabled={disabled}
      >
        <div
          className={clsx(
            "w-5 h-5 my-auto",
            hover ? "fill-white" : disabled ? "fill-gray-600" : "fill-gray-100",
          )}
        >
          {icon}
        </div>
        <p
          className={clsx(
            "text-sm my-auto text-left whitespace-nowrap",
            hover || active
              ? "text-white"
              : disabled
                ? "text-dark-disabled"
                : "text-secondary-dark",
          )}
        >
          {children}
        </p>
      </button>
    </div>
  );
};
